import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-100px symbol-fixed position-relative" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = {
  href: "javascript:void(0)",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = { href: "javascript:void(0)" }
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-4" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" })
], -1)
const _hoisted_18 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_19 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.teacher.employee.photo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.apiUrl + _ctx.teacher.employee.photo,
                    alt: _ctx.teacher.employee.photo
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createBlock(_component_el_avatar, {
                    key: 1,
                    shape: "circle",
                    size: 100,
                    style: {"background-color":"var(--bs-success)","font-size":"50px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.teacher.employee.firstName[0]) + _toDisplayString(_ctx.teacher.employee.lastName[0]), 1)
                    ]),
                    _: 1
                  }))
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.teacher.employee.firstName) + " " + _toDisplayString(_ctx.teacher.employee.lastName), 1),
                  _createElementVNode("a", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_router_link, {
                    to: `/classe/${_ctx.teacher.classRoom}`,
                    class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.teacher.employee.adress), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]),
              _hoisted_16
            ]),
            _hoisted_17
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("ul", _hoisted_19, [
            _createElementVNode("li", _hoisted_20, [
              _createVNode(_component_router_link, {
                to: `/teachers/${_ctx.TeacherID}/overview`,
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("profileOverview")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: `/teachers/${_ctx.TeacherID}/timetable`,
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("dashboard.timetable")), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}